import __request__ from "routing/request";
export function terminateSession(requestOptions) {
  return __request__("DELETE", "/system/sessions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateSession(requestOptions) {
  return __request__("GET", "/system/sessions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function newSession(Loginrequest, requestOptions) {
  return __request__("POST", "/system/sessions", Loginrequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function terminateSessionWithId(sessionId, requestOptions) {
  return __request__("DELETE", `/system/sessions/${sessionId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
